import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";


const AdminDashboard = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [promos, setPromos] = useState([]);
  const [error, setError] = useState("");

  // 🔽 TAMBAHAN STEP C
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    period: "",
    discount: "",
    image: null,
  });

  useEffect(() => {
    const init = async () => {
      try {
        // 1️⃣ Cek auth admin (SESSION)
        const authRes = await fetch("/api/auth/me.php", {
          credentials: "include",
        });

        if (!authRes.ok) {
          navigate("/promo/login");
          return;
        }

        // 2️⃣ Ambil data promo
        await fetchPromos();
        setLoading(false);
      } catch (err) {
        console.error("Auth error:", err);
        navigate("/promo/login");
      }
    };

    init();
  }, [navigate]);

  const fetchPromos = async () => {
    try {
      const res = await fetch("/api/promos/index.php", {
        credentials: "include",
      });

      const result = await res.json();

      // 🔐 DEFENSIVE: pastikan array
      if (Array.isArray(result)) {
        setPromos(result);
      } else if (Array.isArray(result.data)) {
        setPromos(result.data);
      } else {
        setPromos([]);
      }
    } catch (err) {
      console.error("Fetch promo error:", err);
      setError("Gagal memuat data promo");
      setPromos([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFile = (e) => {
    const file = e.target.files?.[0] || null;
    setFormData((prev) => ({ ...prev, image: file }));
  };


  const handleLogout = async () => {
    try {
      await fetch("/api/auth/logout.php", {
        credentials: "include",
      });
    } finally {
      navigate("/promo/login");
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p>Memuat dashboard...</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Admin Dashboard - Honda</title>
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        {/* HEADER */}
        <header className="bg-white border-b px-6 py-4 flex justify-between items-center">
          <h1 className="font-bold text-lg">Admin Promo</h1>

          <div className="flex gap-2">
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-red-600 text-white px-4 py-2 rounded-lg font-semibold"
            >
              + Tambah Promo
            </button>

            <button
              onClick={handleLogout}
              className="text-red-500 hover:underline"
            >
              Logout
            </button>
          </div>
        </header>


        {/* CONTENT */}
        {/* 5xl to 6xl */}
        <main className="p-6 max-w-6xl mx-auto">
          <h2 className="text-xl font-bold mb-4">Daftar Promo</h2>

          {error && (
            <p className="text-red-500 mb-4">{error}</p>
          )}

          {!Array.isArray(promos) || promos.length === 0 ? (
            <p className="text-gray-500">Belum ada promo.</p>
          ) : (
            <div className="space-y-4">
              {promos.map((promo) => (
                <div
                  key={promo.id}
                  className="bg-white border rounded-lg p-4 flex gap-4 items-center"
                >
                  <img
                    src={promo.image ? `/${promo.image}` : "/assets/no-image.png"}
                    alt={promo.title}
                    className="w-32 h-20 object-cover rounded"
                    onError={(e) => {
                      e.currentTarget.src = "/assets/no-image.png";
                    }}
                  />

                  <div className="flex-1">
                    <h3 className="font-bold">{promo.title}</h3>
                    <p className="text-sm text-gray-600">
                      {promo.description}
                    </p>
                    <p className="text-xs text-gray-500 mt-1">
                      {promo.period}
                    </p>
                  </div>

                  {/* nanti di sini tombol edit / delete */}
                </div>
              ))}
            </div>
          )}
        </main>

        {isModalOpen && (
          <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="bg-white w-full max-w-lg rounded-xl p-6">
              <h3 className="text-lg font-bold mb-4">Tambah Promo</h3>

              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  setSaving(true);

                  try {
                    const fd = new FormData();
                    fd.append("title", formData.title);
                    fd.append("description", formData.description);
                    fd.append("period", formData.period);
                    fd.append("discount", formData.discount);
                    if (formData.image) fd.append("image", formData.image);

                    const res = await fetch("/api/promos/create.php", {
                      method: "POST",
                      credentials: "include",
                      body: fd,
                    });

                    const result = await res.json();
                    if (!res.ok || !result.success) {
                      throw new Error(result.message || "Gagal menambah promo");
                    }

                    // sukses
                    setIsModalOpen(false);
                    setFormData({
                      title: "",
                      description: "",
                      period: "",
                      discount: "",
                      image: null,
                    });
                    await fetchPromos();
                  } catch (err) {
                    alert(err.message || "Terjadi kesalahan");
                  } finally {
                    setSaving(false);
                  }
                }}
                className="space-y-4"
              >
                <input
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder="Judul promo"
                  className="w-full border rounded-lg px-3 py-2"
                  required
                />

                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Deskripsi"
                  className="w-full border rounded-lg px-3 py-2"
                  rows={3}
                  required
                />

                <input
                  name="period"
                  value={formData.period}
                  onChange={handleChange}
                  placeholder="Periode (contoh: 1–31 Jan 2026)"
                  className="w-full border rounded-lg px-3 py-2"
                  required
                />

                <input
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                  placeholder="Diskon"
                  className="w-full border rounded-lg px-3 py-2"
                />

                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFile}
                  className="w-full"
                  required
                />

                <div className="flex justify-end gap-2 pt-2">
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="px-4 py-2 rounded-lg border"
                    disabled={saving}
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 rounded-lg bg-red-600 text-white font-semibold"
                    disabled={saving}
                  >
                    {saving ? "Menyimpan..." : "Simpan"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default AdminDashboard;
